module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 138
// module chunks = 0